export default __webpack_public_path__ + "6f163985a589adc9cef083b1eea9405e.svg";